<!--Overrides @basecom-gmbh/pond/components/Shared/SharedQuantityInput.vue-->
<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { Schemas } from '@shopware/api-client/api-types';

const emit = defineEmits(['onUpdate', 'onEnter']);

const handleUpdate = (value: number) => {
    emit('onUpdate', value);
};
const props = defineProps<{
    lineItem?: Schemas['LineItem'];
    product?: Schemas['Product'];
    isLoading?: boolean;
    static?: boolean;
}>();

let quantityInformation = props.product;

if (props.lineItem) {
    quantityInformation = props.lineItem.quantityInformation;
}
</script>

<!--CUSTOM IDS-95: changed styling-->
<template>
    <!-- IDS-84: change styles-->
    <NumberFieldRoot
        :disabled="props.isLoading || props.static"
        :locale="'de-DE'"
        :min="quantityInformation?.minPurchase ?? 1"
        :max="quantityInformation?.maxPurchase ?? 1000"
        :step="quantityInformation?.purchaseSteps ?? 1"
        :default-value="props.static ? props.lineItem?.quantity : (quantityInformation?.purchaseSteps ?? 1)"
        name="quantity"
        class="bg-white flex h-11 w-100 shrink-0 items-center rounded-full border border-gray-medium px-4 sm:text-sm"
        :class="{
            'cursor-not-allowed': props.isLoading || props.static,
        }"
        @update:model-value="handleUpdate($event)"
    >
        
<FormKitLazyProvider config-file="true">
<NumberFieldDecrement
            v-if="!props.static"
            class="flex items-center justify-center data-[disabled]:opacity-20"
        >
            <FormKitIcon
                icon="minus"
                class="block h-4 w-4"
            />
        </NumberFieldDecrement>

        <NumberFieldInput
            class="bg-transparent non-italic w-full text-center font-main text-base font-normal leading-6 focus:outline-none"
            :class="{
                'bg-transparent cursor-not-allowed': props.isLoading || props.static,
            }"
            @keyup.enter="$emit('onEnter', $event)"
        />

        <NumberFieldIncrement
            v-if="!props.static"
            class="flex items-center justify-center data-[disabled]:opacity-20"
        >
            <FormKitIcon
                icon="plus"
                class="block h-4 w-4"
            />
        </NumberFieldIncrement>
</FormKitLazyProvider>

    </NumberFieldRoot>
</template>
